import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from "@angular/core";
import { BehaviorSubject, filter, Observable, Observer } from "rxjs";
import { Ticket } from "../../../model/ticket";
import { TicketService } from "../../../services/ticket.service";
import { AuthService } from "../../../auth.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Messages } from "../../../model/messages";
import { Navigation } from "../../../model/navigation";
import { NavigationHelper } from "../../../services/navigation.helper";
import { PrioritiesService } from "../../../services/priorities.service";
import { Labeler } from "../../../model/labeler";
import { StatusService } from "../../../services/status.service";
import { DepartmentsService } from "../../../services/departaments.service";
import { Active } from "../../../model/filters/active";
import { SingleChoice } from "../../../model/singlechoice";
import { MultiActionService } from "../../../services/multi-action.service";
import { BranchService } from "../../../services/branch.service";
@Component({
    selector: "ticket",

    templateUrl: "./ticket.component.html",
    styleUrls: ["./ticket.component.css"],
})
export class TicketComponent implements OnInit {
    ticketCount: number = 0;
    messages: BehaviorSubject<Messages>;
    tickets: BehaviorSubject<Ticket[]>;
    ticket = new BehaviorSubject<Ticket>(
        new Ticket(0, "", "", "", 0, "", 0, 0, "", 0, 0, "", 0, null, "", false)
    );
    selectedTickets: Ticket[] = [];
    @Output() choiceEvent: EventEmitter<SingleChoice> = new EventEmitter();
    selectedTicket: Ticket | null = null;
    paginatedTickets: Ticket[] = [];
    currentPage: number = 0;
    pageSize: number = 10;
    totalPages: number = 0;
    isSearchExecuted = false;
    completionUrl = new BehaviorSubject<string>("");
    departmentLabeler = new BehaviorSubject<string>("-");
    selectedTicketTitle: string = "";
    @Output() ticketSelected = new EventEmitter<number>();
    @Output() createNewTicket = new EventEmitter<void>();
    @Input() isMobile: boolean = false;
    actionLabeler = new BehaviorSubject<string>("-");
    ticketProcessResults: {
        ticket: Ticket;
        success: boolean;
        message?: string;
    }[] = [];
    constructor(
        public ticketService: TicketService,
        private auth: AuthService,
        private router: Router,
        private nav: NavigationHelper,
        private priority: PrioritiesService,
        private status: StatusService,
        private branch: BranchService,
        private route: ActivatedRoute,
        private department: DepartmentsService,
        private multiActionService: MultiActionService,
        private cdr: ChangeDetectorRef
    ) {
        this.messages = new BehaviorSubject(Messages.EMPTY);
        this.tickets = new BehaviorSubject<Ticket[]>([]);
    }
    ngOnInit(): void {

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                this.updateCurrentPageFromUrl();
            });

        this.nav.topic.subscribe((topic) => {
            if (topic) {
                this.updateCurrentPageFromUrl();
            }
        });
        if (
            this.nav.currentAction !== "choose"
        ) {
            const token = this.auth.token;

            this.ticketService.search(token).subscribe({
                next: (messages) => {
                    if (messages.hasAnyMessages) {
                        this.messages.next(messages);
                    } else {
                        this.isSearchExecuted = true;
                        this.ticketService.currentResults.subscribe((ids) => {
                            if (ids.length > 0) {
                                const lastPage = localStorage.getItem("lastTicketPage");
                                let pageToLoad = 0;

                                if (lastPage !== null) {
                                    const parsedPage = parseInt(lastPage, 10);
                                    if (!isNaN(parsedPage) && parsedPage > 0) {
                                        pageToLoad = parsedPage - 1;
                                    }
                                }

                                this.loadPage(pageToLoad);
                            }
                        });
                    }
                },
            });
        }

        this.updateCurrentPageFromUrl();

        this.ticketService.currentResults.subscribe((ids) => {
            if (ids.length > 0) {
                const lastPage = localStorage.getItem("lastTicketPage");
                const parsedPage = lastPage ? parseInt(lastPage, 10) : NaN;
                const pageToLoad = !isNaN(parsedPage) && parsedPage > 0 ? parsedPage - 1 : 0;
                this.loadPage(pageToLoad);
            } else {
                this.paginatedTickets = [];
                this.cdr.detectChanges();
            }
        });


        if (this.currentPage === 0) {
            const lastPage = localStorage.getItem("lastTicketPage");
            if (lastPage !== null) {
                const parsedPage = parseInt(lastPage, 10);
                if (!isNaN(parsedPage) && parsedPage > 0) {
                    this.currentPage = parsedPage - 1;
                    this.updatePaginatedTickets();
                    if (
                        this.nav.currentAction !== "edit" &&
                        this.nav.currentAction !== "fragmentedit"
                    ) {
                        const url = `tickets/-1/result/page/${parsedPage}`;
                        this.router.navigate([url]);
                    }
                }
            }
        }
    }

    loadPage(pageNumber: number) {
        const token = this.auth.token;

        this.ticketService.getPage(pageNumber + 1, token).subscribe({
            next: (messages) => {
                if (!messages.hasAnyMessages) {
                    this.tickets.next(this.ticketService.ticketData);

                    this.totalPages = Math.ceil(
                        this.ticketService.currentResultIds.length / this.ticketService.pageSize
                    );

                    this.currentPage = pageNumber;

                    this.updatePaginatedTickets();

                    this.cdr.detectChanges();
                }
            }
        });
    }
    goToPage(page: number): void {
        if (page < 0 || page >= this.totalPages) return;

        this.loadPage(page);
        localStorage.setItem("lastTicketPage", String(page + 1));
        const url = `tickets/-1/result/page/${page + 1}`;
        this.router.navigate([url]);
    }

    getPaginationButtons(): (number | string)[] {
        const total = this.totalPages;
        const current = this.currentPage;

        if (total <= 9) {
            return Array.from({ length: total }, (_, i) => i);
        }

        const pages = new Set<number>();
        pages.add(0);
        pages.add(1);
        if (current - 1 > 1) pages.add(current - 1);
        pages.add(current);
        if (current + 1 < total - 2) pages.add(current + 1);
        pages.add(total - 2);
        pages.add(total - 1);

        const sorted = [...pages].sort((a, b) => a - b);
        const result: (number | string)[] = [];
        for (let i = 0; i < sorted.length; i++) {
            if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
                result.push('...');
            }
            result.push(sorted[i]);
        }
        return result;
    }

    changePage(page: number) {
        if (typeof page === "number" && page >= 0 && page < this.totalPages) {
            this.currentPage = page;
            this.updatePaginatedTickets();
        }
    }

    updatePaginatedTickets(): void {
        this.paginatedTickets = this.tickets.value || [];
    }


    toggleSelect(ticket: Ticket) {
        this.ticketService.toggleTicketSelection(ticket);
    }

    isSelected(ticket: Ticket): boolean {
        return this.ticketService.isTicketSelected(ticket);
    }
    select(ticket: Ticket, commentId?: number) {
        this.selectedTicket = ticket;

        if (ticket && ticket.id) {
            const comment = commentId ?? -9;
            localStorage.setItem("lastTicketPage", String(this.currentPage + 1));

            this.ticketService.select(ticket, true);
            this.ticketSelected.emit(ticket.id!);
            this.router.navigate([`tickets/${ticket.id}/fragmentedit/comment/${comment}`])
                .then(() => {
                    const nav = this.nav.freshNavigation;

                });
        }
    }


    createTicket(): void {
        this.createNewTicket.emit();
        const newTicket = new Ticket(
            Navigation.NEW,
            "",
            "",
            "",
            0,
            "",
            0,
            0,
            "",
            0,
            0,
            "",
            0,
            new Date(),
            "",
            false
        );

        this.router.navigate([`tickets/${Navigation.NEW}/edit`]).then(() => {
            const nav = this.nav.freshNavigation;

            this.ticketService.select(newTicket);
            this.ticketSelected.emit(Navigation.NEW);
        });
    }
    relaySingleChoice(choice: SingleChoice) {
        this.nav.startChoice(choice);
    }
    get departmentIdObserver(): Partial<Observer<number>> {
        return {
            next: (id) => {
                this.onDepartmentChoice(id);
            },
        };
    }

    onDepartmentChoice(departmentId: number): void { }

    get departmentId(): number {
        const ticket = this.ticket.value;
        return ticket && ticket.departmentId ? ticket.departmentId : -1;
    }
    get statusLabelerByService(): Labeler {
        return this.status;
    }
    get priorityLabelerByService(): Labeler {
        return this.priority;
    }

    get departmentLabelerByService(): Labeler {
        return this.department;
    }
    get branchLabelerByService(): Labeler {
        return this.branch;
    }
    get actionLabelerByService(): Labeler {
        return this.multiActionService;
    }
    get TRUE(): boolean {
        return true;
    }
    get FALSE(): boolean {
        return false;
    }
    dateFormatted(ticket: Ticket): string {
        const date = ticket.created;

        if (!date) return "";

        const dateParts = date.split("T");
        const parts = dateParts[0].split("-");

        const parsed = new Date(
            Number(parts[0]),
            Number(parts[1]) - 1,
            Number(parts[2])
        );

        const createdYear: number = Number(parts[0]);
        const year = new Date().getFullYear();
        const sameYear = year === createdYear;

        const formatted = sameYear
            ? new Intl.DateTimeFormat(undefined, {
                day: "numeric",
                month: "long",
            }).format(parsed)
            : new Intl.DateTimeFormat(undefined, {
                day: "numeric",
                month: "long",
                year: "numeric",
            }).format(parsed);

        return formatted;
    }

    get startRow(): number {
        return this.currentPage * this.pageSize;
    }

    get endRow(): number {
        return this.startRow + this.paginatedTickets.length;
    }

    updateCurrentPageFromUrl(): void {
        const segments = this.nav.getLastSuccessfulNavigationSegments();
        const pageIndex = segments?.findIndex((seg) => seg === "page");

        if (pageIndex !== -1 && pageIndex + 1 < segments.length) {
            const pageNumber = Number(segments[pageIndex + 1]);
            if (!isNaN(pageNumber) && pageNumber > 0) {
                this.currentPage = pageNumber - 1;
            }
        } else {
            const lastPage = localStorage.getItem("lastTicketPage");
            if (lastPage !== null) {
                const parsedPage = parseInt(lastPage, 10);
                if (!isNaN(parsedPage) && parsedPage > 0) {
                    this.currentPage = parsedPage - 1;
                }
            }
        }

        this.updatePaginatedTickets();
    }
    get isEmptyResult(): boolean {
        return this.isSearchExecuted && this.paginatedTickets.length === 0;
    }

    get actionIdObserver(): Partial<Observer<number>> {
        return {
            next: (id) => {
                this.onActionChoice(id);
            },
        };
    }
    onActionChoice(actionId: number): void {
        this.ticketService.selectMultiActionId(actionId);
    }

    get actionUrlObserver(): Observable<string> {
        return this.ticketService.selectedMultiActionUri;
    }

    isValidChoice(value: any): boolean {
        return value !== null && value !== undefined && value !== 0 && value !== "-";
    }
}
